import useSWR, { mutate } from 'swr';
import { useMemo } from 'react';

interface MenuMasterState {
  isDashboardDrawerOpened: boolean;
}

const initialState: MenuMasterState = {
  isDashboardDrawerOpened: false
};

const endpoints = {
  key: 'api/menu',
  master: 'master'
};

export function useGetMenuMaster() {
  const { data, isLoading } = useSWR<MenuMasterState>(endpoints.key + endpoints.master, () => initialState, {
    revalidateIfStale: false,
    revalidateOnFocus: false,
    revalidateOnReconnect: false
  });

  const memoizedValue = useMemo(
    () => ({
      menuMaster: data ?? initialState,
      menuMasterLoading: isLoading
    }),
    [data, isLoading]
  );

  return memoizedValue;
}

export function handlerDrawerOpen(isDashboardDrawerOpened: boolean) {
  mutate(
    endpoints.key + endpoints.master,
    (currentMenuMaster: MenuMasterState | undefined) => {
      return { ...(currentMenuMaster ?? initialState), isDashboardDrawerOpened };
    },
    false
  );
}
